import { useState, useEffect } from 'react'
import { useAppState, useAppDispatch } from './Context'
import MapInfoWindow from './MapInfoWindow'
import { IconMapMarker } from '@react/common/icons'

function MapMarker({ location }) {
  const [isSelected, setIsSelected] = useState(false)
  const { selectedLocation } = useAppState()
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (selectedLocation === location) {
      setIsSelected(true)
    } else {
      setIsSelected(false)
    }
  }, [selectedLocation])

  const handleClick = (location) => {
    if (selectedLocation === location) {
      dispatch({ type: 'setSelectedLocation', payload: null })
    } else {
      dispatch({ type: 'setSelectedLocation', payload: location })
    }
  }

  const handleClose = () => {
    dispatch({ type: 'setSelectedLocation', payload: null })
  }

  return (
    <div className={`map-location ${isSelected ? 'map-location--selected' : ''}`}>
      {isSelected && <MapInfoWindow location={location} handleClose={handleClose} />}

      <div className="relative cursor-pointer map-marker" onClick={() => handleClick(location)}>
        <IconMapMarker className="w-10 transition-transform xl:w-12" />
      </div>
    </div>
  )
}

export default MapMarker
